<div class="row mt-2 back-btn-height p-2">
  <div class="col-md-5" style="overflow: auto; max-height: 400px">
    @if (
      (isAdmin || isDispatchUser) &&
      selectedEvent?.event_id &&
      ["job update", "incident update", "scheduled patrol update"].includes(
        selectedEvent?.event_type?.toLowerCase()
      )
    ) {
      <div (click)="routeToEventPage()" class="text-end">
        <button class="btn btn-sm btn-outline-primary">View Details</button>
      </div>
    }
    @if (
      (isAdmin || isDispatchUser) &&
      selectedEvent?.checkpoint_details?.id &&
      selectedEvent?.checkpoint_details?.qr_code &&
      !selectedEvent?.checkpoint_details?.is_deleted &&
      !selectedEvent?.checkpoint_details?.is_validated &&
      ["patrol update"].includes(selectedEvent?.event_type?.toLowerCase())
    ) {
      <div
        (click)="onCheckpointRedirect(selectedEvent?.checkpoint_details?.id)"
        class="text-end"
      >
        <button class="btn btn-sm btn-success">Validate Checkpoint</button>
      </div>
    }
    @if (
      selectedEvent?.detail ||
      canEditEventUpdate ||
      canDeleteRestoreCommentPhoto
    ) {
      <div>
        @if (scanDistanceInfo?.scanDistance) {
          <div class="text-danger my-2">
            Scanned outside configured checkpoint radius
          </div>
        }
        <dl>
          <!--additional information-->
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>
                <span>
                  {{
                    selectedEvent?.event_action !== 6
                      ? selectedEvent?.action
                      : "Scanned QR Checkpoint"
                  }}
                  @if (
                    (isAdmin || isDispatchUser) &&
                    selectedEvent?.checkpoint_details?.id &&
                    selectedEvent?.checkpoint_details?.qr_code &&
                    !selectedEvent?.checkpoint_details?.is_deleted &&
                    !selectedEvent?.checkpoint_details?.is_validated &&
                    ["patrol update"].includes(
                      selectedEvent?.event_type?.toLowerCase()
                    )
                  ) {
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      class="ms-2"
                      [attr.title]="'This will not show on reports until the checkpoint has been validated.'"
                    >
                      <i class="fa-solid fa-circle-info"></i>
                    </span>
                  }
                </span>
                @if (editedDetails?.updated_at) {
                  <span>
                    | Edited [
                    {{
                      editedDetails?.updated_at | customDate: "d MMM y HH:mm"
                    }}
                    ]
                  </span>
                }
              </dt>
            </div>
            @if (canEditEventUpdate) {
              <div (click)="editUserComment.emit(selectedEvent)" class="mx-2">
                <span>
                  <i
                    class="fa-regular fa-comment-dots md-font-size text-secondary"
                  ></i>
                </span>
              </div>
            }
            @if (canDeleteRestoreCommentPhoto) {
              <div
                (click)="
                  deleteRestoreUserUpdate.emit({
                    event: selectedEvent,
                    type: selectedEvent?.is_deleted ? 'restore' : 'delete',
                  })
                "
                class="ms-1"
              >
                @if (selectedEvent?.is_deleted) {
                  <span>
                    <i
                      class="fa-solid fa-trash-can-arrow-up md-font-size text-secondary"
                    ></i>
                  </span>
                } @else {
                  <span>
                    <i
                      class="fa-solid fa-trash md-font-size text-secondary"
                    ></i>
                  </span>
                }
              </div>
            }
          </div>
          <dd class="gt-multi-line">
            {{ selectedEvent?.detail }}
            @if (selectedEvent?.eta) {
              <span
                >[ETA:
                {{ selectedEvent?.eta | customDate: "d MMM y HH:mm" }} ]</span
              >
            }
            @if (
              selectedEvent?.user_provided_timestamp &&
              (selectedEvent?.user_provided_timestamp
                | customDate: "d MMM y HH:mm") !=
                (selectedEvent?.updated_at | customDate: "d MMM y HH:mm")
            ) {
              <span>
                [{{
                  selectedEvent?.user_provided_timestamp
                    | customDate: "d MMM y HH:mm"
                }}]
              </span>
            }
            @if (
              selectedEvent?.event_action === 1 &&
              selectedEvent?.status_identity === 12 &&
              selectedEventFrom === "job" &&
              selectedEvent?.event_add_info?.event_value
            ) {
              <div>
                Reason: {{ selectedEvent?.event_add_info?.event_value }}
              </div>
            }
          </dd>
          <div class="small-font text-secondary text-end">
            @if (deletedDetails?.updated_at) {
              <div>
                Deleted:
                {{ deletedDetails?.updated_at | customDate: "d MMM y HH:mm" }}
                |
                {{ deletedDetails?.user_name }}
              </div>
            }
            @if (restoredDetails?.updated_at && !selectedEvent?.is_deleted) {
              Restored:
              {{ restoredDetails?.updated_at | customDate: "d MMM y HH:mm" }} |
              {{ restoredDetails?.user_name }}
            }
          </div>
        </dl>
      </div>
    }

    <div class="d-flex flex-wrap column-gap-5 row-gap-3 my-3">
      @for (indColumn of userEventDetailsTableView; track indColumn) {
        @if (
          indColumn.nestedValue
            ? indColumn.nestedValue(selectedEvent)
            : selectedEvent[indColumn.name]
        ) {
          <div>
            <dl>
              <dt class="text-uppercase">
                {{ indColumn?.header }}
              </dt>
              <!--style whole row either based on condition or common to all -->
              @if (indColumn?.datetimeObj == true) {
                <div>
                  <!--a row is typically divided into 3 prefix, main content and suffix, style each of them based on conditions or common -->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalPrefixStyle
                        ? indColumn?.conditionalPrefixStyle(selectedEvent)
                        : indColumn?.prefixStyle
                    "
                  >
                    <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                    {{
                      indColumn?.prefixNestedValue
                        ? indColumn?.prefixNestedValue(selectedEvent)
                        : indColumn?.prefix
                          ? indColumn?.prefix
                          : ""
                    }}
                  </span>
                  <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                  <!-- main content which will be passed from the backend STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalColumnDataStyle
                        ? indColumn?.conditionalColumnDataStyle(selectedEvent)
                        : indColumn?.columnDataStyle
                    "
                  >
                    {{
                      indColumn.nestedValue
                        ? (indColumn.nestedValue(selectedEvent)
                          | customDate
                            : (indColumn.dateTimeFormat
                                ? indColumn.dateTimeFormat
                                : "d MMM y HH:mm"))
                        : (selectedEvent[indColumn.name]
                          | customDate
                            : (indColumn.dateTimeFormat
                                ? indColumn.dateTimeFormat
                                : "d MMM y HH:mm"))
                    }}
                  </span>
                  <!-- main content which will be passed from the backend ENDS-->
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalSuffixStyle
                        ? indColumn?.conditionalSuffixStyle(selectedEvent)
                        : indColumn?.suffixStyle
                    "
                  >
                    {{
                      indColumn?.suffixNestedValue
                        ? indColumn?.suffixNestedValue(selectedEvent)
                        : indColumn?.suffix
                          ? indColumn?.suffix
                          : ""
                    }}
                  </span>
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                </div>
              }
              <!-- rows where objects are datetime objects ENDS-->
              <!-- rows where objects are normal objects STARTS-->
              <!--style whole row either based on condition or common to all -->
              @if (indColumn?.datetimeObj !== true) {
                <div>
                  <!--a row is typically divided into 3 prefix, main content and suffix, style each of them based on conditions or common -->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalPrefixStyle
                        ? indColumn?.conditionalPrefixStyle(selectedEvent)
                        : indColumn?.prefixStyle
                    "
                  >
                    <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                    {{
                      indColumn?.prefixNestedValue
                        ? indColumn?.prefixNestedValue(selectedEvent)
                        : indColumn?.prefix
                          ? indColumn?.prefix
                          : ""
                    }}
                  </span>
                  <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                  <!-- main content which will be passed from the backend STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalColumnDataStyle
                        ? indColumn?.conditionalColumnDataStyle(selectedEvent)
                        : indColumn?.columnDataStyle
                    "
                    class="gt-multi-line"
                  >
                    @if (
                      indColumn?.isGuardColumn && selectedEvent?.subs_user_id
                    ) {
                      <span
                        [gtappPopover]="userDetailPopoverTemplate"
                        [popoverData]="{ userId: selectedEvent?.subs_user_id }"
                      >
                        {{
                          indColumn.nestedValue
                            ? indColumn.nestedValue(selectedEvent)
                            : selectedEvent[indColumn.name] == "null" ||
                                selectedEvent[indColumn.name] == "undefined"
                              ? "N/A"
                              : selectedEvent[indColumn.name]
                        }}
                      </span>
                    } @else {
                      {{
                        indColumn.nestedValue
                          ? indColumn.nestedValue(selectedEvent)
                          : selectedEvent[indColumn.name] == "null" ||
                              selectedEvent[indColumn.name] == "undefined"
                            ? "N/A"
                            : selectedEvent[indColumn.name]
                      }}
                    }
                  </span>
                  <!-- main content which will be passed from the backend ENDS-->
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalSuffixStyle
                        ? indColumn?.conditionalSuffixStyle(selectedEvent)
                        : indColumn?.suffixStyle
                    "
                  >
                    {{
                      indColumn?.suffixNestedValue
                        ? indColumn?.suffixNestedValue(selectedEvent)
                        : indColumn?.suffix
                          ? indColumn?.suffix
                          : ""
                    }}
                  </span>
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                </div>
              }
            </dl>
          </div>
        }
      }
      @if (selectedEvent?.job_type_name) {
        <div>
          <dl>
            <dt class="text-uppercase">Job Type</dt>
            <dd>
              {{ selectedEvent?.job_type_name }}
            </dd>
          </dl>
        </div>
      }
      @if (selectedEvent?.acknowledge_info?.updated_at) {
        <dl>
          <dt>Guard has been contacted</dt>
          <dd>
            {{ selectedEvent?.acknowledge_info?.inquired ? "Yes" : "No" }}
          </dd>
        </dl>
      }
      @if (selectedEvent?.acknowledge_info?.comment) {
        <dl>
          <dt class="text-uppercase">Actions Taken / Details</dt>
          <dd>{{ selectedEvent?.acknowledge_info?.comment }}</dd>
        </dl>
      }
      @if (selectedEvent?.checkpoint_details?.min_distance) {
        <div>
          <dl>
            <dt class="text-uppercase">Geofence Radius (metres)</dt>
            <dd>
              {{
                selectedEvent?.checkpoint_details?.min_distance
                  | number: "1.0-0"
              }}
            </dd>
          </dl>
        </div>
      }
    </div>
    @if (selectedEvent | misc: "serverReceivedDateTimeCheck") {
      <div class="mb-2">
        <dl>
          <dt class="text-danger fw-bold d-flex align-items-center">
            RECEIVED AT
            <span
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              class="ms-2"
              title="The time this event was uploaded."
            >
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </dt>
          <dd>
            {{
              selectedEvent
                | misc: "serverReceivedDateTimeCheck"
                | date: "d MMM y HH:mm"
            }}
          </dd>
        </dl>
      </div>
    }
    @if (selectedEvent?.prompts?.length) {
      @for (item of selectedEvent?.prompts; track item) {
        <div class="my-3">
          <div class="fw-bold">
            {{
              item?.prompt_data?.name ? item?.prompt_data?.name : "Mobile Form"
            }}
          </div>
          @for (dataItem of item?.data; track dataItem) {
            <div>
              <ng-template
                *ngTemplateOutlet="promptTemplate; context: { value: dataItem }"
              ></ng-template>
            </div>
          }
        </div>
      }
    }
    @if (selectedEvent?.device_details && (isAdmin || isDispatchUser)) {
      <div class="d-flex flex-wrap column-gap-5 row-gap-3">
        @for (item of selectedEvent?.device_details | keyvalue; track item) {
          <div>
            @if (item?.value) {
              <dl>
                <dt class="text-uppercase">
                  {{ item.key }}
                </dt>
                <dd class="text-break">{{ item.value }}</dd>
              </dl>
            }
          </div>
        }
        @if (
          browserGpsInfo?.[selectedEvent?.gps?.source]?.description &&
          selectedEvent?.gps?.lat &&
          selectedEvent?.gps?.lon
        ) {
          <div>
            <dl>
              <dt>GPS Accuracy</dt>
              <dd>
                {{ browserGpsInfo?.[selectedEvent?.gps?.source]?.description }}
              </dd>
            </dl>
          </div>
        }
      </div>
    }
  </div>

  <div class="col-md-7">
    <div
      [ngClass]="selectedEvent?.file ? 'row row-cols-md-2' : 'row row-cols-1'"
    >
      @if (selectedEvent?.file) {
        @if (selectedEvent?.file_additional_info?.uploading) {
          <div
            class="justify-content-end d-flex align-items-center gap-2 alert alert-info height-fit-content"
          >
            <div>File has not been uploaded to the server yet.</div>
            <div
              class="spinner-border text-dark spinner-border-sm"
              role="status"
            ></div>
          </div>
        } @else {
          <div class="col-md-6 my-2" (click)="onOpenFile(selectedEvent)">
            @if (
              [".mp4", ".mov", ".webm", ".mkv"].includes(
                selectedEvent?.file_extension
              )
            ) {
              <video
                controls
                style="
                  max-height: 100%;
                  max-width: 100%;
                  display: flex;
                  width: 100%;
                "
              >
                <source src="{{ selectedEvent?.file }}" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            } @else {
              <img
                class="cursor-pointer mw-100 border border-secondary"
                src="{{ selectedEvent?.file }}"
                alt="Guard Tracker"
              />
            }
          </div>
        }
      }
      @if (isAdmin || isDispatchUser) {
        <div [ngClass]="selectedEvent?.file ? 'col-md-6' : 'col'">
          @if (selectedEvent?.gps?.lat) {
            <gtapp-map-leaflet
              [latLon]="selectedEvent?.gps"
              [scannedCheckpointDetails]="selectedEvent?.checkpoint_details"
              [mapId]="'event-location'"
            ></gtapp-map-leaflet>
          }
        </div>
      }
    </div>
  </div>
</div>
<div class="row mt-3 bottom-section" id="fixedBtn">
  <div class="px-3 pb-2">
    <button
      class="btn btn-dark d-block d-md-none w-100 btn-lg"
      (click)="hideDetails()"
    >
      Back
    </button>
  </div>
</div>

<!--looped prompt template-->
<ng-template let-dataItem="value" #promptTemplate>
  @if (dataItem?.description) {
    <div>
      <dl>
        <dt class="text-uppercase">{{ dataItem?.description }}</dt>
        <dd>{{ dataItem | misc: "promptValue" }}</dd>
      </dl>
    </div>
  }

  @if (dataItem?.file_id && promptFileDataUrls?.[dataItem?.file_id]?.file_url) {
    <img
      (click)="onOpenFile(promptFileDataUrls?.[dataItem?.file_id])"
      src="{{ promptFileDataUrls?.[dataItem?.file_id]?.file_url }}"
      height="120"
      width="120"
      class="small-img-preview"
    />
  }
  @for (option of dataItem?.options; track option) {
    <div>
      <ng-template
        *ngTemplateOutlet="promptTemplate; context: { value: option }"
      ></ng-template>
    </div>
  }
</ng-template>
